import api from './api';

export interface PedidoResponse {
  id: number;
  codigo_pedido: string;
  valor_total: number;
  valor: number;
  desconto?: number;
  data_criacao: string;
  tipo_pagamento: string;
  status: {
    id: number;
    valor: string;
    descricao?: string;
  };
  empresa?: {
    id: number;
    nome_fantasia?: string;
    razao_social?: string;
    cnpj: string;
    email?: string;
    telefone?: string;
  };
  agendamentos?: Array<{
    id: number;
    pedido_id?: number;
    colaborador_id: number;
    exame_id: number;
    variacao_id?: number;
    variacao_exame_clinico_id?: number;
    clinica_id: number;
    data_agendamento: string;
    valor_variacao?: number;
    avulso?: boolean;
    escolha_clinica_tipo?: 'rh' | 'colaborador';
    token_escolha_clinica?: string;
    colaborador: {
      id: number;
      nome: string;
      cpf: string;
      data_admissao?: string;
      data_demissao?: string;
    };
    exame: {
      id: number;
      nome: string;
    };
    exame_clinico?: {
      id: number;
      nome: string;
      preco?: number;
    };
    variacao?: {
      id: number;
      nome: string;
      variacao_exame_clinico?: Array<{
        id: number;
        preco?: number;
        exame_clinico: {
          id: number;
          nome: string;
        };
      }>;
    };
    clinica: {
      id: number;
      nome: string;
    };
    status: {
      id: number;
      valor: string;
      descricao?: string;
    };
  }>;
}

class PedidosService {
  /**
   * Busca detalhes de um pedido por codigo_pedido
   * @param codigo - Código do pedido
   * @returns Promise com detalhes do pedido
   */
  async getPedidoByCodigo(codigo: string): Promise<PedidoResponse> {
    const response = await api.get<PedidoResponse>(`/agendamentos/pedido/${codigo}`);
    return response.data;
  }
}

export const pedidosService = new PedidosService();














